import React, { ReactElement } from 'react';
import { Image } from 'semantic-ui-react';
import styles from './index.scss';
import classnames from 'classnames';
import { CheckCircle } from 'components/icons';
import { H1 } from 'components/typography';
import { HelpTooltip } from 'components/tooltip';
import { titleWithBlueLine } from 'components/form-engine/utils';

export interface ITitleProps {
  title: any;
  id?: any;
  subtitle?: any;
  className?: string;
  check?: boolean;
  titleClassName?: string;
  subtitleClassName?: string;
  tooltip?: ReactElement;
  tooltipProps?: any;
  img?: string;
  svgClassName?: string;
  providerName?: string;
  svgIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  isNewMSLifePage?: boolean;
  lifePageIndex?: number;
  formId?: string;
}
// TODO: This components is being used so many places, we need to refactor this.
const Title = ({
  id,
  check,
  title,
  titleClassName,
  subtitle,
  subtitleClassName,
  tooltip,
  tooltipProps,
  className,
  img,
  svgClassName,
  providerName,
  svgIcon: SvgIcon,
  isNewMSLifePage,
  lifePageIndex,
  formId,
}: ITitleProps) => (
  <div id={id} className={classnames(styles.titleContainer, className)}>
    <H1
      className={classnames(
        styles.title,
        check && styles.withCheck,
        titleClassName,
        providerName && styles.purchaseSurveyTitle,
        isNewMSLifePage && styles.newMarketScanTitle,
      )}
    >
      {check && <CheckCircle />}
      {img && <Image className={styles.image} src={img} />}
      {SvgIcon && <SvgIcon className={classnames(styles.svg, svgClassName)} />}
      {title}
      {tooltip && (
        <HelpTooltip
          basic={true}
          {...tooltipProps}
          position={tooltipProps?.position || 'bottom center'}
          content={tooltip}
          className={classnames(styles.tooltip, tooltipProps?.className)}
          toggleClassName={classnames(
            styles.toggle,
            tooltipProps?.toggleClassName,
          )}
        />
      )}
    </H1>
    {isNewMSLifePage && <span className={styles.blueBorder}></span>}
    {titleWithBlueLine(formId || '') && (
      <span className={styles.blueBorder}></span>
    )}
    {subtitle && (
      <div
        className={classnames(
          styles.subtitle,
          subtitleClassName,
          isNewMSLifePage && styles.newLifeSubtitle,
        )}
      >
        <span>{subtitle}</span>
        {isNewMSLifePage && (
          <div className={styles.pagination}>
            <span
              className={lifePageIndex === 1 ? styles.active : styles.nonActive}
            ></span>
            <span
              className={lifePageIndex === 1 ? styles.nonActive : styles.active}
            ></span>
          </div>
        )}
      </div>
    )}
  </div>
);

export default Title;
